import { Link, useParams } from "react-router-dom";
import { useEffect, useState, CSSProperties } from "react";
import { detailcommande } from "../../../Modeles/Commande";
import DetailCommandeService from "../../../Services/Admin/DetailCommandeService";
import { NewSideBarAdmin } from "../../NewSideBarAdmin";
import { formatCodeCommande } from "../../../Services/CodeTrackingHelper";

export interface CommandeType {
  product: detailcommande[];
  messageErrors: string;
}

export default function DetailCommande({
  MessageSucess,
  MessageError,
  handleSubmitUpdate,
  ValideCommande,
  handleAnnuleCommande,
}: {
  MessageSucess?: string;
  handleSubmitUpdate?: (ref: string, nommagasin: string, qte: number, id:any) => Promise<any> | any;
  ValideCommande?: (id: any) => Promise<any> | any;
  handleAnnuleCommande?: (id: number) => Promise<any> | any;
  MessageError?: string;
}) {
  const { id } = useParams();
  const [state, setState] = useState<CommandeType>({
    product: [] as detailcommande[],
    messageErrors: "Aucune commande",
  });
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [loading, setLoading] = useState(false);
  const [actionLoading, setActionLoading] = useState<Record<string, boolean>>({});

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const res = await DetailCommandeService(id).getCommandeDetailsAdmin();
        setState((prev) => ({ ...prev, product: res.data }));
      } catch (error) {
        setState((prev) => ({ ...prev, messageErrors: "Erreur de chargement" }));
      } finally {
        setLoading(false);
      }
    };
    fetchData();

    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [id]);

  const { product } = state;
  const totalCommande = product && product.length > 0
    ? product.reduce((acc, curr) => acc + (Number(curr.prix || 0) * Number(curr.quantity || 1)), 0)
    : 0;

  const [confirmPopup, setConfirmPopup] = useState(false);

  const handleValideClick = async (idCommande: any, itemId: any) => {
    if (ValideCommande) {
      const key = `${itemId}_valide`;
      setActionLoading((prev) => ({ ...prev, [key]: true }));
      try {
        await ValideCommande(itemId);
        setState((prev) => ({
          ...prev,
          product: prev.product.map((p) =>
            p.id === itemId ? { ...p, Statut: "valider" } : p
          ),
        }));
      } finally {
        setActionLoading((prev) => ({ ...prev, [key]: false }));
      }
    }
  };

  const handleConfirmClick = async (ref: string, vendeur: string, quantity: number, idCommande: any, itemId: any) => {
    if (handleSubmitUpdate) {
      const key = `${itemId}_confirm`;
      setActionLoading((prev) => ({ ...prev, [key]: true }));
      setConfirmPopup(true);
      try {
        await handleSubmitUpdate(ref, vendeur, quantity, itemId);
        setState((prev) => ({
          ...prev,
          product: prev.product.map((p) =>
            p.id === itemId ? { ...p, Statut: "confirmé" } : p
          ),
        }));
      } finally {
        setActionLoading((prev) => ({ ...prev, [key]: false }));
        setConfirmPopup(false);
      }
    }
  };

  const handleAnnulerClick = async (id: number) => {
    if (handleAnnuleCommande) {
      const key = `${id}_annule`;
      setActionLoading((prev) => ({ ...prev, [key]: true }));
      try {
        await handleAnnuleCommande(id);
        setState((prev) => ({
          ...prev,
          product: prev.product.map((p) =>
            p.id === id ? { ...p, Statut: "annulé" } : p
          ),
        }));
      } finally {
        setActionLoading((prev) => ({ ...prev, [key]: false }));
      }
    }
  };

  const handleGoBack = () => window.history.back();

  const C = {
    bg: "#f8fafc",
    surface: "#ffffff",
    surfaceAlt: "#f1f5f9",
    border: "#e2e8f0",
    accent: "#FFC400",
    accentDim: "rgba(59, 130, 246, 0.1)",
    textPrimary: "#0f172a",
    textSecondary: "#64748b",
    textMuted: "#94a3b8",
    green: "#10b981",
    greenDim: "rgba(16, 185, 129, 0.1)",
    red: "#ef4444",
    redDim: "rgba(239, 68, 68, 0.1)",
    orange: "#f59e0b",
    orangeDim: "rgba(245, 158, 11, 0.1)",
    blue: "#3b82f6",
    blueDim: "rgba(59, 130, 246, 0.1)",
  };

  const s: Record<string, CSSProperties> = {
    wrapper: {
      minHeight: "100vh",
      fontFamily: "'DM Sans', 'Segoe UI', sans-serif",
      backgroundColor: C.bg,
      color: C.textPrimary,
    },
    main: {
      marginLeft: isMobile ? 0 : "260px",
      padding: isMobile ? "16px 12px" : "40px 32px",
      maxWidth: "1200px",
    },
    header: {
      display: "flex",
      alignItems: "center",
      gap: "16px",
      marginBottom: "32px",
    },
    backBtn: {
      width: "40px",
      height: "40px",
      borderRadius: "10px",
      border: `1px solid ${C.border}`,
      backgroundColor: C.surface,
      color: C.accent,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      fontSize: "22px",
      transition: "all 0.2s",
      flexShrink: 0,
    },
    titleWrapper: {
      display: "flex",
      flexDirection: "column",
      gap: "2px",
    },
    title: {
      fontSize: isMobile ? "18px" : "22px",
      fontWeight: 700,
      margin: 0,
      letterSpacing: "-0.3px",
    },
    subtitle: {
      fontSize: "13px",
      color: C.textSecondary,
      margin: 0,
    },
    accentLine: {
      width: "36px",
      height: "3px",
      backgroundColor: C.accent,
      borderRadius: "2px",
      marginTop: "4px",
    },
    loaderWrap: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      height: "400px",
      gap: "16px",
    },
    loaderRing: {
      width: "44px",
      height: "44px",
      border: `3px solid ${C.border}`,
      borderTop: `3px solid ${C.accent}`,
      borderRadius: "50%",
      animation: "spin 0.8s linear infinite",
    },
    tableCard: {
      backgroundColor: C.surface,
      borderRadius: "16px",
      border: `1px solid ${C.border}`,
      overflow: "hidden",
      boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.05)",
    },
    table: {
      width: "100%",
      borderCollapse: "collapse",
      fontSize: "14px",
    },
    thead: {
      backgroundColor: C.surfaceAlt,
    },
    th: {
      padding: "14px 18px",
      textAlign: "left",
      fontSize: "11px",
      fontWeight: 600,
      textTransform: "uppercase",
      letterSpacing: "0.8px",
      color: C.textMuted,
      borderBottom: `1px solid ${C.border}`,
      whiteSpace: "nowrap",
    },
    td: {
      padding: "14px 18px",
      borderBottom: `1px solid ${C.border}`,
      color: C.textPrimary,
      verticalAlign: "middle",
    },
    tdMuted: {
      padding: "14px 18px",
      borderBottom: `1px solid ${C.border}`,
      color: C.textSecondary,
      verticalAlign: "middle",
      fontFamily: "'JetBrains Mono', monospace",
      fontSize: "13px",
    },
    idBadge: {
      display: "inline-block",
      backgroundColor: C.accentDim,
      color: C.accent,
      padding: "2px 10px",
      borderRadius: "6px",
      fontWeight: 700,
      fontSize: "13px",
      fontFamily: "'JetBrains Mono', monospace",
    },
    qtyBadge: {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      minWidth: "32px",
      height: "28px",
      backgroundColor: C.surfaceAlt,
      border: `1px solid ${C.border}`,
      borderRadius: "6px",
      fontWeight: 600,
      fontSize: "13px",
      padding: "0 8px",
    },
    card: {
      backgroundColor: C.surface,
      border: `1px solid ${C.border}`,
      borderRadius: "14px",
      marginBottom: "14px",
      overflow: "hidden",
      boxShadow: "0 2px 4px rgba(0,0,0,0.02)",
    },
    cardHeader: {
      backgroundColor: C.surfaceAlt,
      padding: "10px 14px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      borderBottom: `1px solid ${C.border}`,
    },
    cardRow: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "10px 14px",
      borderBottom: `1px solid ${C.border}`,
    },
    cardLabel: {
      fontSize: "11px",
      fontWeight: 600,
      textTransform: "uppercase",
      color: C.textMuted,
    },
    cardValue: {
      fontSize: "14px",
      fontWeight: 500,
    },
    actionGroup: {
      display: "flex",
      gap: "8px",
      flexWrap: "wrap",
    },
    btnConfirm: {
      display: "inline-flex",
      alignItems: "center",
      gap: "4px",
      backgroundColor: C.greenDim,
      color: C.green,
      border: `1px solid rgba(16, 185, 129, 0.3)`,
      padding: "6px 12px",
      borderRadius: "6px",
      fontWeight: 600,
      fontSize: "12px",
      cursor: "pointer",
      transition: "all 0.2s",
    },
    btnValider: {
      display: "inline-flex",
      alignItems: "center",
      gap: "4px",
      backgroundColor: C.blueDim,
      color: C.blue,
      border: `1px solid rgba(59, 130, 246, 0.3)`,
      padding: "6px 12px",
      borderRadius: "6px",
      fontWeight: 600,
      fontSize: "12px",
      cursor: "pointer",
      transition: "all 0.2s",
    },
    btnCancel: {
      display: "inline-flex",
      alignItems: "center",
      gap: "4px",
      backgroundColor: C.redDim,
      color: C.red,
      border: `1px solid rgba(239, 68, 68, 0.3)`,
      padding: "6px 12px",
      borderRadius: "6px",
      fontWeight: 600,
      fontSize: "12px",
      cursor: "pointer",
      transition: "all 0.2s",
    },
  };

  const StatutBadge = ({ statut }: { statut: string }) => {
    let bg = C.redDim, color = C.red, border = "rgba(239,68,68,0.3)";
    if (statut === "en cours..") { bg = C.orangeDim; color = C.orange; border = "rgba(245,158,11,0.3)"; }
    if (statut === "confirmé") { bg = C.greenDim; color = C.green; border = "rgba(16,185,129,0.3)"; }
    if (statut === "valider") { bg = C.blueDim; color = C.blue; border = "rgba(59,130,246,0.3)"; }
    const dot = statut === "en cours.." ? "●" : statut === "confirmé" || statut === "valider" ? "✓" : "✕";
    return (
      <span style={{
        display: "inline-flex", alignItems: "center", gap: "5px",
        backgroundColor: bg, color, border: `1px solid ${border}`,
        padding: "3px 10px", borderRadius: "20px",
        fontSize: "12px", fontWeight: 600,
      }}>
        <span style={{ fontSize: "8px" }}>{dot}</span>
        {statut}
      </span>
    );
  };

  const renderActions = (pro: any) => {
    if (pro.Statut === "annulé") {
      return <span style={{ color: C.textMuted, fontSize: "12px", fontWeight: 500 }}>—</span>;
    }
    
    const isLoadingConfirm = actionLoading[`${pro.id}_confirm`];
    const isLoadingValide = actionLoading[`${pro.id}_valide`];
    const isLoadingAnnule = actionLoading[`${pro.id}_annule`];
    const isAnyLoading = isLoadingConfirm || isLoadingValide || isLoadingAnnule;

    return (
      <div style={s.actionGroup}>
        <button 
          style={{ ...s.btnValider, opacity: isAnyLoading ? 0.6 : 1 }}
          disabled={isAnyLoading}
          onClick={() => handleValideClick(pro.idCommande, pro.id)}
        >
          {isLoadingValide ? <i className="bi bi-hourglass-bottom"></i>: "✓ Valider"}
        </button>
        <button 
          style={{ ...s.btnConfirm, opacity: isAnyLoading ? 0.6 : 1 }}
          disabled={isAnyLoading}
          onClick={() => handleConfirmClick(pro.RefArticle, pro.vendeur, pro.quantity, pro.idCommande, pro.id)}
        >
          {isLoadingConfirm ? <i className="bi bi-hourglass-bottom"></i>: "✓ Confirmer"}
        </button>
        <button 
          style={{ ...s.btnCancel, opacity: isAnyLoading ? 0.6 : 1 }}
          disabled={isAnyLoading}
          onClick={() => handleAnnulerClick(pro.id)}
        >
          {isLoadingAnnule ? <i className="bi bi-hourglass-bottom"></i>: "✕ Annuler"}
        </button>
      </div>
    );
  };

  return (
    <div style={s.wrapper}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=JetBrains+Mono:wght@500;700&display=swap');
        * { box-sizing: border-box; }
        @keyframes spin { to { transform: rotate(360deg); } }
        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(14px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        .cmd-row { animation: fadeUp 0.35s ease both; }
        .cmd-row:nth-child(1)  { animation-delay: 0.04s; }
        .cmd-row:nth-child(2)  { animation-delay: 0.08s; }
        .cmd-row:hover td { background-color: #f8fafc !important; }
        .cmd-card { animation: fadeUp 0.3s ease both; }
        button:disabled { cursor: not-allowed; }
      `}</style>
      
      <NewSideBarAdmin />
      
      {confirmPopup && (
        <div style={{
          position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: "rgba(0,0,0,0.5)", zIndex: 9999,
          display: "flex", alignItems: "center", justifyContent: "center",
          backdropFilter: "blur(2px)"
        }}>
          <div style={{
            backgroundColor: "#fff", padding: "30px", borderRadius: "16px",
            boxShadow: "0 10px 25px rgba(0,0,0,0.2)", textAlign: "center", maxWidth: "400px", margin: "20px"
          }}>
            <div style={{ fontSize: "40px", marginBottom: "15px", animation: "spin 2s linear infinite" }}><i className="bi bi-hourglass-bottom"></i></div>
            <h3 style={{ margin: "0 0 10px 0", fontSize: "20px", color: C.textPrimary }}>Traitement en cours</h3>
            <p style={{ margin: 0, color: C.textSecondary, fontSize: "15px", lineHeight: "1.5" }}>
              Attendez la confirmation de la commande et aussi la mise à jour du stock...
            </p>
          </div>
        </div>
      )}

      
      <div style={s.main}>
        <div style={s.header}>
          <button onClick={handleGoBack} style={s.backBtn}>
            <i className="bi bi-arrow-left-short" />
          </button>
          <div style={s.titleWrapper}>
            <h4 style={s.title}>Détails de la commande {formatCodeCommande('', id)} (Admin)</h4>
            <p style={s.subtitle}>
              {product.length > 0 ? `${product.length} article(s)` : "Aucun article"}
            </p>
            <div style={s.accentLine} />
          </div>
        </div>

        {MessageSucess && (
          <div style={{ backgroundColor: C.greenDim, border: `1px solid rgba(16,185,129,0.3)`, color: C.green, borderRadius: "10px", padding: "12px 16px", marginBottom: "20px", fontSize: "14px", fontWeight: 500 }}>
            ✓ {MessageSucess}
          </div>
        )}
        {MessageError && (
          <div style={{ backgroundColor: C.redDim, border: `1px solid rgba(239,68,68,0.3)`, color: C.red, borderRadius: "10px", padding: "12px 16px", marginBottom: "20px", fontSize: "14px", fontWeight: 500 }}>
            ✕ {MessageError}
          </div>
        )}

        {loading ? (
          <div style={s.loaderWrap}>
            <div style={s.loaderRing} />
            <span style={{ color: C.textSecondary, fontSize: "13px" }}>Chargement des commandes…</span>
          </div>
        ) : isMobile ? (
          <div>
            {product && product.length > 0 ? (
              product.map((pro, i) => (
                <div key={pro.idCommande} className="cmd-card" style={{ ...s.card, animationDelay: `${i * 0.06}s` }}>
                  <div style={s.cardHeader}>
                    <span style={s.idBadge}>#{pro.idCommande}</span>
                    <StatutBadge statut={pro.Statut} />
                  </div>
                  {[
                    { label: "Article", value: pro.NomArticle },
                    { label: "Référence", value: pro.RefArticle },
                    { label: "Vendeur", value: pro.vendeur },
                    { label: "Prix", value: `${pro.prix} MAD` },
                    { label: "Quantité", value: pro.quantity },
                    { label: "Date", value: pro.created_at },
                  ].map(({ label, value }) => (
                    <div key={label} style={s.cardRow}>
                      <span style={s.cardLabel}>{label}</span>
                      <span style={s.cardValue}>{value}</span>
                    </div>
                  ))}
                  <div style={{ padding: "12px 14px" }}>
                    {renderActions(pro)}
                  </div>
                </div>
              ))
            ) : (
              <div style={{ textAlign: "center", padding: "60px 20px", color: C.textMuted }}>Aucune commande trouvée</div>
            )}

            {!loading && product && product.length > 0 && (
              <div style={{
                backgroundColor: "#fff",
                border: `1.5px solid ${C.border}`,
                borderRadius: "12px",
                padding: "16px",
                marginTop: "16px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                boxShadow: "0 2px 4px rgba(0,0,0,0.04)"
              }}>
                <span style={{ fontWeight: 700, color: C.textPrimary, fontSize: "15px" }}>Montant Total :</span>
                <span style={{ fontWeight: 800, color: C.accent, fontSize: "18px" }}>{totalCommande.toFixed(2)} MAD</span>
              </div>
            )}
          </div>
        ) : (
          <div style={s.tableCard}>
            <div style={{ overflowX: "auto" }}>
              <table style={s.table}>
                <thead style={s.thead}>
                  <tr>
                    {["N° Commande", "Référence", "Article", "Vendeur", "Prix", "Quantité", "Statut", "Action"].map((h) => (
                      <th key={h} style={s.th}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {product && product.length > 0 ? (
                    product.map((pro) => (
                      <tr key={pro.idCommande} className="cmd-row" style={{ transition: "background 0.15s" }}>
                        <td style={s.td}><span style={s.idBadge}>#{pro.idCommande}</span></td>
                        <td style={s.tdMuted}>{pro.RefArticle}</td>
                        <td style={{ ...s.td, fontWeight: 500 }}>{pro.NomArticle}</td>
                        <td style={s.td}>{pro.vendeur}</td>
                        <td style={{ ...s.td, fontWeight: 600 }}>{pro.prix} <span style={{ color: C.textMuted, fontSize: "12px" }}>MAD</span></td>
                        <td style={s.td}><span style={s.qtyBadge}>{pro.quantity}</span></td>
                        <td style={s.td}><StatutBadge statut={pro.Statut} /></td>
                        <td style={s.td}>
                          {renderActions(pro)}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={8} style={{ padding: "60px 20px", textAlign: "center", color: C.textMuted }}>Aucune commande trouvée</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {!loading && product && product.length > 0 && (
              <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '16px 20px', borderTop: `1px solid ${C.border}` }}>
                <div style={{
                  background: '#F8FAFC',
                  padding: '12px 24px',
                  borderRadius: '10px',
                  border: `1.5px solid ${C.border}`,
                  display: 'flex',
                  alignItems: 'center',
                  gap: '20px'
                }}>
                  <span style={{ fontSize: '14px', fontWeight: 600, color: C.textSecondary }}>Montant Total Commande :</span>
                  <span style={{ fontSize: '18px', fontWeight: 800, color: C.accent }}>
                    {totalCommande.toFixed(2)} MAD
                  </span>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}